module.exports = __webpack_public_path__ + "static/media/disconnect.585b6d55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/disconnect.svg
// module id = 107
// module chunks = 0